import 'fslightbox'

window.addEventListener('bw-refresh-lightbox', () => {
  // @ts-ignore
  refreshFsLightbox()
})
